<template>
  <div class="container" ref="container"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "Chart",
  props: {
    options: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    theme: {
      type: String,
      default: "",
      required: false,
    },
  },
  data() {
    return {
      chart: null, // 保存 ECharts 实例
    };
  },
  mounted() {
    this.initChart();
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
    if (this.chart) {
      this.chart.dispose(); // 销毁实例，释放内存
    }
  },
  watch: {
    options: {
      handler(newOptions) {
        if (this.chart) {
          this.chart.setOption(newOptions);
        }
      },
      deep: true, // 深度监听，确保对象内部变化也能触发更新
    },
  },
  methods: {
    initChart() {
      const container = this.$refs.container;
      if (container) {
        // 使用 props 中的 theme（原代码中为 this.options.theme，此处保持原逻辑）
        this.chart = echarts.init(container, this.options.theme);
        this.chart.setOption(this.options);
      }
    },
    resizeHandler() {
      if (this.chart) {
        this.chart.resize();
      }
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}
</style>